module.exports = __webpack_public_path__ + "media/images/sp/brands/tvb/store_kyoto-40e6707930c3be0a283e8c17e264f04c.jpg";